import axios from "axios";
import { LoginCredentials, RegisterData, User, ApiResponse } from "../types";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/api";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Add token to requests if it exists
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle token expiration
api.interceptors.response.use(
  (response) => response.data, // Extract data from response
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

const authService = {
  login: async (credentials: LoginCredentials): Promise<any> => {
    try {
      const response = await api.post("/login", credentials);
      console.log("Login API response:", response); // DEBUG
      return response;
    } catch (error) {
      console.error("Login API error:", error); // DEBUG
      throw error;
    }
  },

  register: async (userData: RegisterData): Promise<any> => {
    try {
      const response = await api.post("/register", userData);
      console.log("Register API response:", response); // DEBUG
      return response;
    } catch (error) {
      console.error("Register API error:", error); // DEBUG
      throw error;
    }
  },

  logout: async (): Promise<void> => {
    await api.post("/logout");
  },

  getCurrentUser: async (): Promise<any> => {
    try {
      const response = await api.get("/me");
      console.log("Current user API response:", response); // DEBUG
      return response;
    } catch (error) {
      console.error("Current user API error:", error); // DEBUG
      throw error;
    }
  },

  refreshToken: async (): Promise<any> => {
    const response = await api.post("/refresh");
    return response;
  },
};

export default authService;
